export const EXPORT_PDF_DETAIL_EVAL_SUCCESS = "EXPORT_PDF_DETAIL_EVAL_SUCCESS";

export const CHANGE_STYLE_SUCCESS = "CHANGE_STYLE_SUCCESS";
export const CHANGE_STYLE_FAIL = "CHANGE_STYLE_FAIL";

export const OPEN_DETAIL_EVAL_SUCCESS = "OPEN_DETAIL_EVAL_SUCCESS";
export const CLOSE_DETAIL_EVAL_SUCCESS = "CLOSE_DETAIL_EVAL_SUCCESS";
export const CHANGE_SCORE_SUCESS = "CHANGE_SCORE_SUCESS";
export const CHANGE_TAB_SUCESS = "CHANGE_TAB_SUCESS";
export const CHANGE_TAB2_SUCESS = "CHANGE_TAB2_SUCESS";
export const CHANGE_TAB4_SUCESS = "CHANGE_TAB4_SUCESS";
export const CHANGE_TAB3_SUCESS = "CHANGE_TAB3_SUCESS";
export const CHANGE_SUM_SUCESS = "CHANGE_SUM_SUCESS";
export const CHANGE_SELECTEDTAB_SUCESS = "CHANGE_SELECTEDTAB_SUCESS";
export const CHANGE_SELECTEDTAB2_SUCESS = "CHANGE_SELECTEDTAB2_SUCESS";
export const CHANGE_STATUS_SUCCESS = "CHANGE_STATUS_SUCCESS";

export const OPEN_DETAIL_GRILLE_SUCCESS = "OPEN_DETAIL_GRILLE_SUCCESS";
export const CLOSE_DETAIL_GRILLE_SUCCESS = "CLOSE_DETAIL_GRILLE_SUCCESS";

export const CHANGE_TAB_FILTER_LIST_SUCESS = "CHANGE_TAB_FILTER_LIST_SUCESS";